module.exports = __webpack_public_path__ + "static/media/IntroImage.23201489.png";